// @owners { team: patients-team }
import { createSelector } from 'reselect';
import { SPECIALTY_STATUS } from '~shared/features/users/constants';
import getUserSpecialtyStatus from '~shared/features/users/selectors/getUserSpecialtyStatus';

export const getIsVideosEnabled = createSelector(
  [getUserSpecialtyStatus],
  (specialtyStatus) => specialtyStatus === SPECIALTY_STATUS.FERTILITY,
);
